import React from 'react';
import { saveAs } from 'file-saver';
// import { XLSX } from 'xlsx';
import * as XLSX from 'xlsx/xlsx.mjs';
import { Button } from 'react-bootstrap';
import { COLOR_APP, COLOR_TEXT } from '../../../constants';

const DownloadExcelButton = () => {
    const handleDownload = () => {
        const excelData = [
            [
                "ລະຫັດ CF", "ຊື່ສິນຄ້າ", "ຫົວຫນວ່ຍ", "ຈໍານວນ", "ລາຄາຕົ້ນທືນ", "ລາຄາຂາຍ", "ສະກຸນເງິນ"
            ],
            [
                "ນ12", "ຊຸດນອນ", "ຜືນ", 1, 29000, 59000, "ກີບ"
            ],
            [
                "ນ13", "ເສື້ອກັນໜາວ", "ຜືນ", 3, 15000, 45000, "ກີບ"
            ],
            [
                "ນ17", "ກະເປົາ", "ໂຕ", 2, 8, 29, "ບາດ"
            ],
            [
                "ນ18", "ເກີບ", "ຄູ່", 1, 280, 535, "ບາດ"
            ],
            [
                "ນ19", "ດອກໄຟປ້ອມ", "ດອກ", 5, 25, 60, "ໂດລາ"
            ],
            [
                "ນ2", "ຊຸດກິລາ", "ຊຸດ", 2, 6, 10, "ໂດລາ"
            ],
            [
                "ນ20", "ຈອກ", "ໃບ", 2, 8, 20, "ໂດລາ"
            ]
        ];


        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Convert the workbook to an array buffer
        const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Save the Excel file using FileSaver.js
        const file = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(file, 'bbbb-sample-file.xlsx');

        // const file = new Blob([excelData], { type: 'application/vnd.ms-excel' });
        // saveAs(file, 'lailaolab-sample-excel-file.xls');
    };

    return (
        <Button onClick={handleDownload} style={{ borderColor: COLOR_TEXT, color: COLOR_TEXT, background: 'transparent', fontWeight: 'bold', whiteSpace: 'nowrap' }}>ຮູບແບບຕົວຢ່າງ Excel</Button>
    );
};

export default DownloadExcelButton;
